import { render, staticRenderFns } from "./fundos-investimento.vue?vue&type=template&id=7e63d001&scoped=true&"
import script from "./fundos-investimento.vue?vue&type=script&lang=js&"
export * from "./fundos-investimento.vue?vue&type=script&lang=js&"
import style0 from "./fundos-investimento.vue?vue&type=style&index=0&id=7e63d001&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e63d001",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VRow})
